import React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import "../components.css";
import { mapDispatchToProps, mapStateToProps } from "../../helpers";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const MobileFormStepper = (props) => {
  const { t } = useTranslation();
  let html = props.steps;
  let elem_ids = props.elem_ids;
  localStorage.setItem("stepperLength", elem_ids.length);
  const handleNext = (index) => {
    props.stepperBackStep(false);
    props.activeStep(index);
  };
  function toTitleCase(str) {
    return str
      .replace(/^./, str[0].toUpperCase())
      .replace(/([A-Z])([a-z])/g, " $1$2")
      .trim();
  }
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#F9FAFB",
          borderBottom: "1px solid rgba(228, 231, 236, 1)",
          marginBottom: 3,
          p: 1,
        }}
      >
        <Typography
          sx={{
            flexGrow: 1,
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "600",
            color: "#212121",
          }}
        >
          {`${props.reduxActiveStep + 1}/${elem_ids.length}  ${toTitleCase(
            t(props.elem_ids[props.reduxActiveStep])
          )}`}
        </Typography>
      </Box>
      <div>{html[props.reduxActiveStep]}</div>
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MobileFormStepper);
